export default __webpack_public_path__ + "videos/knowledge-hub-tree3220.mp4";